export const PAGE_LIMIT = 300;

export const IsSingleInstallment = (item): boolean => {
    return item?.installment?.length <= 1;
}